import { render, staticRenderFns } from "./SurveyDetails.vue?vue&type=template&id=c3b7fa24&scoped=true&"
import script from "./SurveyDetails.vue?vue&type=script&lang=ts&"
export * from "./SurveyDetails.vue?vue&type=script&lang=ts&"
import style0 from "./SurveyDetails.vue?vue&type=style&index=0&id=c3b7fa24&lang=scss&scoped=true&"
import style1 from "./SurveyDetails.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3b7fa24",
  null
  
)

export default component.exports